import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import ReportApi from "../api/reportApi"
import { Const } from "../../../core/const/const"
import { t } from "i18next"
import { Bounce, toast } from "react-toastify"
import { Card, LoadIndicator } from "../../../core/components"

interface QualityCheckSummaryProps {
    qualityCheckId?: string
}

export const QualityCheckSummary: React.FC<QualityCheckSummaryProps> = (props) => {
    const { id } = useParams()
    const [report, setReport] = useState<string | undefined>(undefined)
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (!id)
            return

        getReport(parseInt(id))
    }, [id])

    const getReport = async (id: number) => {
        setLoading(true)
        const report = await ReportApi.getQualityCheckReport(id)
        if (!report) {
            showWarningWithId(t("Failed to load quality check report"), "error")
        }
        setLoading(false)
        setReport(report)
    }

    function showWarningWithId(message: string, id: string) {
        toast("Report doesn't exist or you dont have permissions to see it", {
            position: "top-right",
            autoClose: 5000,
            toastId: id,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            type: "warning",
            transition: Bounce
        });
    }

    return (
        <Card padding={1} minHeight={300} style={{ display: "flex", flexDirection: "column", height: "97%" }}>
            <h2>Quality Check Summary</h2>

            <LoadIndicator loading={loading} />

            {report &&
                <iframe
                    src={report}
                    width={"100%"}
                    height={1200}
                    title="Quality Check Report"
                    style={{ border: "none", borderRadius: Const.borderRadiusSmall, marginBottom: "-4px" }} />
            }
        </Card>
    )
}
